import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import SelectComponent from 'components/common/SelectComponent'

const LabeledSelectComponent = ({
  label,
  name,
  onChange,
  children,
  required = false,
  missingFields = [],
  ...rest
}) => {
  const { t } = useTranslation()
  const isMissing = missingFields?.includes?.(name) || missingFields?.has?.(name)

  return (
    <div>
      <label htmlFor={rest?.id || name} className='block text-sm font-medium text-gray-700'>
        {label}{required && ' *'}
      </label>
      <SelectComponent
        name={name}
        onChange={onChange}
        className={`mt-1 ${isMissing ? 'border-orange-500' : ''}`}
        {...rest}
      >
        <option key='' value=''>{t('mgmt.common.selectOption')}</option>
        {children}
      </SelectComponent>
    </div>
  )
}

LabeledSelectComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  isFieldMissing: PropTypes.func,
  children: PropTypes.node,
  missingFields: PropTypes.array
}

LabeledSelectComponent.defaultProps = {
  required: false,
  isFieldMissing: () => false,
  missingFields: []
}

export default LabeledSelectComponent
